<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">


        <h1 class="title-default">Cadastros</h1>
        <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Cadastros</span>! Aqui você encontra
            os
            cadastros gerais do seu sistema.</p>
        <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
    </div>
</div>